import React, { useEffect, useState, useRef, useCallback } from 'react';
import styles from '../css/comuns/carrossel.module.css';

const Carousel = ({ images, mobileImages, interval = 5000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [progress, setProgress] = useState(0);
    const progressTimer = useRef(null);
    const slideTimer = useRef(null);

    const startTimers = useCallback(() => {
        clearInterval(progressTimer.current);
        clearTimeout(slideTimer.current);

        setProgress(0);
        progressTimer.current = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    return 100;
                }
                return prev + (100 / interval) * 10;
            });
        }, 10);

        slideTimer.current = setTimeout(() => {
            setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
        }, interval);
    }, [interval, images.length]);

    useEffect(() => {
        startTimers();
        return () => {
            clearInterval(progressTimer.current);
            clearTimeout(slideTimer.current);
        };
    }, [currentIndex, startTimers]);

    const handleIndicatorClick = (index) => {
        setCurrentIndex(index);
    };

    const renderCarousel = (imageSet, id, className) => (
        <div id={id} className={`${styles['carousel-container']} ${styles[className]}`}>
            <div className="carousel-inner">
                {imageSet.map((img, index) => (
                    <div key={index} className={`carousel-item ${index === currentIndex ? 'active' : ''}`}>
                        <img src={img} alt={`Slide ${index + 1}`} className={`d-block w-100 ${styles['carousel-item']}`} />
                    </div>
                ))}
            </div>
            <button
                className={`carousel-control-prev ${styles['carousel-control-prev']}`}
                type="button"
                onClick={() => setCurrentIndex((prevIndex) => (prevIndex - 1 + imageSet.length) % imageSet.length)}
            >
                <span className={`carousel-control-prev-icon ${styles['carousel-control-prev-icon']}`} aria-hidden="true"></span>
                <span className="visually-hidden">Anterior</span>
            </button>
            <button
                className={`carousel-control-next ${styles['carousel-control-next']}`}
                type="button"
                onClick={() => setCurrentIndex((prevIndex) => (prevIndex + 1) % imageSet.length)}
            >
                <span className={`carousel-control-next-icon ${styles['carousel-control-next-icon']}`} aria-hidden="true"></span>
                <span className="visually-hidden">Próximo</span>
            </button>
            <div className={styles['progress-indicators']}>
                {imageSet.map((_, index) => (
                    <button
                        key={index}
                        type="button"
                        className={`${styles['progress-indicator']} ${index === currentIndex ? 'active' : ''}`}
                        onClick={() => handleIndicatorClick(index)}
                        aria-label={`Slide ${index + 1}`}
                    >
                        <div
                            className={styles.progress}
                            style={{ width: index === currentIndex ? `${progress}%` : '0%' }}
                        ></div>
                    </button>
                ))}
            </div>
        </div>
    );

    return (
        <>
            {renderCarousel(images, 'carouselDesktop', 'desktop')}
            {renderCarousel(mobileImages, 'carouselMobile', 'mobile')}
        </>
    );
};

export default Carousel;